<template>
  <div class="avatar-wrapper"
       :class="{'avatar--centered': centered}"
       @click="handleClick">
    <img v-if="!initials"
         :src="avatarUrl"
         :class="[
          size && `avatar-${size}`,
          {
            'avatar-square': !circle,
            'avatar--no-radius': noRadius,
            'avatar--autosize': autoSize
          }]"
         class="user-avatar border-gray">
  </div>
</template>
<script>
  export default {
    name: 'base-avatar',
    props: {
      /**
       * User store data
       */
      user: {
        type: Object,
        default: () => {
        }
      },
      name: {
        type: String
      },
      /**
       * Show first name and last name initials, instead image/default image
       */
      initials: {
        type: Boolean,
        default: false
      },
      /**
       * Custom image url used as default
       */
      defaultImage: {
        type: String,
        default: 'static/img/mike.jpg'
      },
      centered: Boolean,
      noRadius: Boolean,
      src: {
        type: String
      },
      size: {
        type: String,
        default: ''
      },
      circle: {
        type: Boolean,
        default: true
      },
      autoSize: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      avatarUrl () {
        if (this.src && this.src.toLowerCase() !== 'null'){
          return this.src
        }
        return this.$avatar.generate(this.name ? this.name : this.user)
      }
    },
    methods: {
      handleClick () {
        /**
         * Handle user avatar click
         * @event click
         * @type string
         */
        this.$emit('click')
      }
    },
    watch: {
      avatarUrl(newUrl) {
        this.$emit('change', newUrl);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .avatar-wrapper .user-avatar {
    border-radius: 50%;
    min-width: 48px;
    width: 48px;
    height: auto;

    &.avatar-sm {
      min-width: 36px;
      width: 36px;
      height: auto;
    }

    &.avatar-lg {
      width: 96px;
      height: auto;
    }

    &.avatar-xl {
      width: 144px;
      height: auto;
    }

  }

  .avatar--centered {
    width: 100%;
  }

  .avatar-wrapper .avatar-square {
    border-radius: $border-radius-base;
  }

  .avatar-wrapper .avatar--no-radius {
    border-radius: 0;
  }

  .avatar-wrapper .avatar--autosize {
    height: auto;
    width: auto;
    max-width: 48px;

    &.avatar-sm {
      max-width: 32px;
    }

    &.avatar-lg {
      max-width: 96px;
    }

    &.avatar-xl {
      max-width: 144px;
    }
  }
</style>
